import { Card } from "antd";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Fragment, useMemo } from "react";

interface TransactionDataProps {
  data: any;
  monthNumber: any;
  selectedYear: any;
}

export const TransctionData = ({
  data,
  monthNumber,
  selectedYear,
}: TransactionDataProps) => {
  const options = useMemo(() => {
    if (!data || !data.Series) return {};

    // Main series
    const series = data.Series.filter((s: any) => s.Name).map((s: any) => ({
      name: s.Name,
      data: s.Data.map((item: any) => ({
        name: item.Name,
        y: item.Y,
        drilldown: item.Name + "_" + s.Name,
      })),
      color: s.Name === "Captured" ? "#5bc0de" : "#f0ad4e",
    }));

    // Drilldown series
    const drilldownSeries = data.DrilDown.map((d: any) => ({
      id: d.Id,
      name: `${d.Name} ${
        d.Id.includes("Captured") ? "Captured" : "Uncaptured"
      }`,
      data: d.Data.map((pair: [number, number]) => [`${pair[0]}`, pair[1]]),
      color: d.Id.includes("Captured") ? "#5bc0de" : "#f0ad4e",
    }));

    return {
      chart: {
        type: "column",
        backgroundColor: "transparent",
      },

      title: {
        text: "Captured vs Uncaptured Transactions",
        style: { fontSize: "16px", fontWeight: "bold", color: "#000" },
      },

      xAxis: {
        type: "category",
        labels: {
          style: { fontSize: "12px", color: "#000" },
        },
      },

      yAxis: {
        title: {
          text: "Transaction Count",
          style: { color: "#000" },
        },
        labels: { style: { color: "#000" } },
      },

      legend: {
        enabled: true,
        itemStyle: { color: "#000", fontWeight: "bold" },
      },

      tooltip: {
        useHTML: true,
        formatter: function () {
          const isDrill = this.series.userOptions.id !== undefined;
          const monthName: any = this.series.name.split(" ")[0]; // e.g. "November"
          if (isDrill) {
            return `
              <div style="font-size:14px; font-weight:600;">
                          <div>Date: ${
                            this.point.name
                          } ${monthName} ${new Date().getFullYear()}</div>
                <div>Count : ${this.point.y}</div>
              </div>
            `;
          }

          return `
            <div style="font-size:14px; font-weight:600;">
              <b>${this.series.name}</b><br/>
              ${this.point.name} : ${this.point.y}
            </div>
          `;
        },
        style: { fontSize: "14px", fontWeight: "bold" },
      } as any,

      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            color: "#000",
          },
        },
      },

      series,
      drilldown: {
        breadcrumbs: {
          position: { align: "right" },
          style: { color: "#000", fontWeight: "bold" },
        },
        series: drilldownSeries,
      },

      credits: { enabled: false },
    };
  }, [data, monthNumber, selectedYear]); // <-- FIXED DEPENDENCIES

  return (
    <Fragment>
      <Card bordered style={{ borderRadius: 0, border: "1px solid #d9d9d9" }}>
        <div style={{ width: "100%", height: "400px" }}>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      </Card>
    </Fragment>
  );
};
